"use strict";

exports.__esModule = true;
exports.RestAPIContext = void 0;
var _RestAPI = require("./RestAPI");
var _Utils = require("../../../Utils");
/**
 * Provides a rest api to consumers.
 * @component
 */
var RestAPIContext = exports.RestAPIContext = (0, _Utils.createEnhancedContext)({
  propName: "api",
  defaultController: _RestAPI.RestAPI
});